//业务类型
export const BUSINESS_TYPE = {
    TRANSPORT: '3',
    DELIVERY: '4',
}
export const YES_OR_NO = {
    YES: '2',
    NO: '1',
}
//绩效状态
export const PERFORM_STATUS = {
    WAIT_PUSH: '1', //待推送供应商,
    WAIT_CONFIRM: '2', //待供应商确认
    WAIT_CHECK: '3', //待复核
    WAIT_APPROVE: '4', //待审批
    APPROVING: '5', //审批中
    VALID: '6', //绩效生效
}
//操作类型
export const ACTION_TYPE = {
    APPEAL: '1', //绩效申诉
    SUBMIT_PLAN: '2', //提交绩效帮扶计划
    RECTIFY: '3', //绩效整改
    CHANGE: '4', //绩效调整
    PUSH: '5', //推送供应商
    POSTING: '6', //添加发文
    SUBMIT_APPROVE: '7', //提交绩效审批
    APPROVE_REJECT: '8', //审批驳回
    APPROVE_PASS: '9', //审批通过
    APPEAL_REJECT: '10', //驳回申诉
    CONFIRM: '11', //确认绩效
}
//绩效整改提交状态
export const RECTIFY_SUBMIT = {
    WAIT_SUBMIT: '1', //待提交
    SUBMITED: '2', //已提交
}
//次月整改状况
export const NEXT_MONTH_STATUS = {
    STANDARD: '1', //已达标
    UNSTANDARD: '2', //未达标
    RECTIFY: '3', //整改中
}
//绩效层级
export const PERFORMANCE_DIMENSION_TYPE = {
    COMPANY: '1', //分公司
    PLATFORM: '2', //服务平台
    CUSTOMER: '3', //服务平台（内外部客户）
    COMPANY_CUSTOMER: '5', //分公司（内外部客户）
}


